class StreamingJSONParser {
    constructor() {
        this.buffer = '';
    }

    parse(chunk) {
        this.buffer += chunk;

        try {
            // Try to parse the entire buffered content
            const parsed = JSON.parse(this.buffer);
            // If successful, reset buffer and return the parsed object
            this.buffer = '';
            return parsed;
        } catch (error) {
            // If parsing fails, it means the JSON is incomplete
            // Keep the buffer as is and return null
            return null;
        }
    }
}

export default StreamingJSONParser;